export default __webpack_public_path__ + "static/media/fa-solid-900.3a24a60e.eot";